import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";

// Helper functions
const moneyFormat = (amount: number) => {
	if (!amount && amount !== 0) return "0.00";
	return amount.toLocaleString("en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

// ==================== CURRENCY EXCHANGE COLUMNS ====================
export const currencyExchangeColumns: ColumnDef<any>[] = [
	{
		accessorKey: "currency",
		header: "Currency",
		size: 220,
		minSize: 180,
		maxSize: 350,
		cell: ({ getValue }) => {
			const currency = getValue() as any;
			return currency?.name || "--";
		},
	},
	{
		accessorKey: "buyRate",
		header: "Buy Rate",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "sellRate",
		header: "Sell Rate",
		size: 200,
		minSize: 150,
		maxSize: 300,
		cell: ({ getValue }) => moneyFormat(getValue() as number),
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		maxSize: 250,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		maxSize: 150,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];

// Default column visibility
export const currencyExchangeColumnVisibility = {
	currency: true,
	buyRate: true,
	sellRate: true,
	createdAt: true,
	modifiedAt: true,
	actions: true,
};
